<template>
  <b-container v-if="!loading" class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Odberné miesta
          <small>({{ count }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="table.filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        >
          <template #filter>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Komodita:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="energetic"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.type"
                      :options="[
                        { id: 1, name: 'Elektrina' },
                        { id: 2, name: 'Plyn' },
                        { id: 3, name: 'Voda' },
                        { id: 4, name: 'Teplo' },
                      ]"
                      :searchable="false"
                      @input="search"
                      @select="changeFilterType"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.type = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Stav:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="state"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.state"
                      :options="[
                        { id: 1, name: 'Aktívne' },
                        { id: 2, name: 'Neaktívne' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.state = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Typ merania:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="measureType"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.measureType"
                      :options="[
                        { id: 1, name: 'Mesačná' },
                        { id: 2, name: 'Ročná' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.measureType = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="table.filter.type === 1" md="4">
                <b-form-group
                  label="Napäťová úroveň:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="voltageVolume"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.voltageVolume"
                      :options="[
                        { id: 3, name: 'NN' },
                        { id: 2, name: 'VN' },
                        { id: 1, name: 'VVN' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.voltageVolume = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-if="tariffList.length" md="4">
                <b-form-group
                  :label="
                    table.filter.type === 1
                      ? 'Distrib. sadzba:'
                      : 'Tarifná skupina:'
                  "
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="tariff"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.tariff"
                      :options="tariffList"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.tariff = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Ostatné:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="others"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.others"
                      :options="[
                        { id: 1, name: 'S varovaním' },
                        { id: 2, name: 'Pripojené OM' },
                        { id: 3, name: 'Odpojené OM' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.others = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </input-filter>
      </div>
      <template v-if="$root.user.isAdmin">
        <div class="ml-3">
          <b-dropdown
            class="mr-1"
            menu-class="dropdown-menu-animated"
            right
            size="lg"
            variant="secondary"
          >
            <template #button-content>
              <b-icon icon="gear" />
            </template>
            <b-dropdown-item-button @click="exportEnergetics">
              <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
              Exportovať
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="exportAddresses">
              <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
              Exportovať adresy OM
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
      </template>
    </div>
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <server-table
          ref="table"
          :api-request="apiRequest"
          :columns="table.columns"
          :searchable="false"
          :sort-by.sync="table.sortBy"
          bordered
          hover
          striped
          @refreshed="onLoaded"
        >
          <template #cell(actions)="data">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item
                :to="{
                  name: 'customerView',
                  params: { id: data.item.customer_id },
                }"
              >
                <b-icon class="mr-1" icon="person" />
                Prejsť na zákazníka
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'customerEnergetics',
                  params: {
                    id: data.item.customer_id,
                    energetics_id: data.item.id,
                  },
                }"
              >
                <b-icon class="mr-1" icon="grid" />
                Prejsť na odberné miesto
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                :to="{
                  name: 'customerEnergeticTechnicalTab',
                  params: {
                    id: data.item.customer_id,
                    energetics_id: data.item.id,
                  },
                }"
              >
                <b-icon class="mr-1" icon="wrench" />
                Technické hodnoty
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'customerEnergeticContractTab',
                  params: {
                    id: data.item.customer_id,
                    energetics_id: data.item.id,
                  },
                }"
              >
                <b-icon class="mr-1" icon="vector-pen" />
                Zmluvné hodnoty
              </b-dropdown-item>
              <b-dropdown-item
                v-if="data.item._type.const === 'POWER'"
                :to="{
                  name: 'customerEnergeticDeviceTab',
                  params: {
                    id: data.item.customer_id,
                    energetics_id: data.item.id,
                  },
                }"
              >
                <b-icon class="mr-1" icon="hdd-network" />
                Prístroje
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                :to="{
                  name: 'reportConsumer',
                  params: { energetics_id: data.item.id },
                }"
              >
                <b-icon class="mr-1" icon="file-earmark-text" />
                Fakturačné dáta
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  data.item._type.const === 'POWER' ||
                  data.item._type.const === 'GAS'
                "
                :to="{
                  name: 'reportPerformance',
                  params: { energetics_id: data.item.id },
                }"
              >
                <b-icon class="mr-1" icon="graph-up" />
                Výkonové dáta
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  data.item._type.const === 'POWER' && data.item.energy_data
                "
                :to="{
                  name: 'intervalData',
                  params: { energetics_id: data.item.id },
                }"
              >
                <b-icon class="mr-1" icon="calendar4-week" />
                Intervalové dáta
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template #cell(energetics)="data">
            <div v-if="data.item.warnings" class="warning">
              {{ data.item.warnings }}
            </div>
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="text-nowrap">
                <template v-if="data.item._type.const === 'POWER'">
                  <b-badge class="bg-power align-middle">
                    <icon class="icon-fw" name="plug" scale="0.75" />
                  </b-badge>
                  {{ data.item.powerNumber }}
                </template>
                <template v-if="data.item._type.const === 'GAS'">
                  <b-badge class="bg-gas align-middle">
                    <icon class="icon-fw" name="fire" scale="0.75" />
                  </b-badge>
                  {{ data.item.gasNumber }}
                </template>
                <template v-if="data.item._type.const === 'WATER'">
                  <b-badge class="bg-water align-middle">
                    <icon class="icon-fw" name="tint" scale="0.75" />
                  </b-badge>
                  {{ data.item.waterNumber }}
                </template>
                <template v-if="data.item._type.const === 'HEAT'">
                  <b-badge class="bg-heat align-middle">
                    <icon class="icon-fw" name="sun" scale="0.75" />
                  </b-badge>
                  {{ data.item.heatNumber }}
                </template>
                <template
                  v-if="
                    data.item.energy_data &&
                    data.item.energy_data.energetics_id &&
                    !data.item.energy_data.deleted_at
                  "
                >
                  <b-icon
                    icon="circle-fill"
                    class="text-primary"
                    scale="0.5x"
                  />
                </template>
                <b-badge
                  v-if="!data.item.active"
                  variant="danger"
                  class="align-middle"
                >
                  NEAKTÍVNE
                </b-badge>
              </div>
              <div>
                <b-badge v-if="data.item._voltageVolume">
                  {{ data.item._voltageVolume.name }}
                </b-badge>
                <b-badge v-if="data.item._tariff" class="ml-1">
                  {{ data.item._tariff.name }}
                </b-badge>
              </div>
            </div>
            <div class="fs-sm text-muted">
              {{ data.item.localityName }}
            </div>
          </template>
        </server-table>
      </div>
    </div>
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import Selectbox from '@/components/inputs/Selectbox'
import ServerTable from '@/components/ServerTable'

export default {
  components: {
    InputFilter,
    Selectbox,
    ServerTable,
  },
  data() {
    return {
      loading: false,
      energetics: [],
      table: {
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'energetics',
            label: 'Odberné miesto',
            tdClass: 'pr-4',
            sortable: true,
            sortableKey: 'powerNumber, gasNumber, waterNumber, heatNumber',
            searchable: true,
          },
          {
            key: 'customer',
            label: 'Názov spoločnosti',
            formatter: (value, key, item) => item.customer.name || '-',
            sortable: true,
            sortableKey: 'customers.name',
            searchable: true,
          },
          {
            key: 'customerGroup',
            label: 'Skupina',
            formatter: (value, key, item) =>
              item.customer.group ? item.customer.group.name : '-',
            sortable: true,
            sortableKey: 'customer_groups.name',
            searchable: true,
          },
          {
            key: 'provider',
            label: 'Súčasný dodávateľ',
            formatter: (value, key, item) =>
              item.contract && item.contract._provider
                ? item.contract._provider.name
                : '-',
            sortable: true,
            sortableKey: 'energetic_contracts.providerID',
            searchable: true,
          },
          {
            key: 'measureType',
            label: 'Typ merania',
            formatter: (value, key, item) =>
              item._measureType ? item._measureType.name : '-',
            sortable: true,
            sortableKey: 'measureTypeID',
          },
        ],
        sortBy: 'customer',
        filter: {
          type: null,
          state: null,
          measureType: null,
          voltageVolume: null,
          tariff: null,
          others: null,
        },
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      count: null,
      tariffAttrs: [],
    }
  },
  computed: {
    tariffList() {
      if (this.table.filter.type) {
        return this.tariffAttrs.filter((i) =>
          i.typeID.includes(this.table.filter.type),
        )
      }
      return []
    },
  },
  created() {
    this.$api
      .get('attributes/get', {
        params: {
          select: 'energetics.tariff',
        },
      })
      .then((res) => {
        this.tariffAttrs = res.data
      })
  },
  methods: {
    apiRequest(params) {
      return this.$api.get('energetics/get_list', {
        params: { filter: this.table.filter, ...params },
      })
    },
    onLoaded() {
      this.count = this.$refs.table.totalRows
    },
    search() {
      this.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.table.reset()
    },
    changeFilterType() {
      this.table.filter.voltageVolume = null
      this.table.filter.tariff = null
    },
    exportEnergetics() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('energetics/export', {
          params: {
            query: this.$refs.filter.value,
            filter: this.table.filter,
            ...this.$refs.table.getRequestParams(),
            startAt: 0,
            maxResults: -1,
          },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(new Blob([res.data]), 'odberne-miesta.xlsx')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
    exportAddresses() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('energetics/export_addresses', {
          params: {
            query: this.$refs.filter.value,
            filter: this.table.filter,
            ...this.$refs.table.getRequestParams(),
            startAt: 0,
            maxResults: -1,
          },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(new Blob([res.data]), 'odberne-miesta_adresy.xlsx')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
    rebuild(id) {
      this.$api
        .get('energy_data/rebuild/' + id)
        .then((res) => {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: res.data.success,
            timer: 5000,
          })
        })
        .catch((err) => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: err.response.data.error,
            timer: 5000,
          })
        })
    },
  },
}
</script>
